
export enum VideocallMessageType {
  MODULE_LOADED = 'module;loaded',
  MODULE_SCENE_LOADED = 'module;sceneloaded',
  CALL_STARTED = 'call;started',
  CALL_NEW_CONNECTION = 'call;newconnection',
  CALL_DISCONNECTED = 'call;disconnected',
  CALL_RECORD_STARTED = 'call;recordStarted',
  CALL_RECORD_STOPPED = 'call;recordStopped',
  ANNOTATION_TEXT = 'annotation;text',
  CALL_CLOSED = 'dm;close', // TODO fix this
  MODULE_UNLOADED = 'module;unloaded',
}
